<template>
  <hm-content title="会员列表">
    <div class="table-panel flex item-center">
      <el-input
        clearable
        v-model.trim="keyWord"
        placeholder="输入会员姓名/手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-date-picker
        v-model="dateAndTime"
        type="datetimerange"
        size="small"
        class="mr10"
        start-placeholder="注册时间"
        end-placeholder="注册时间"
        :default-time="['00:00:00', '23:59:59']"
      ></el-date-picker>
      <el-button
        type="primary"
        size="small"
        @click="search"
        placeholder="输入名称"
        >查询</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="memberList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
          label="序号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="mobilePhone"
          label="手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="regTimeFormat"
          width="140px"
          label="注册时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rankMoney"
          label="累计消费金额"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rankServerTimes"
          label="累计服务次数"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="lastStoreOutlet"
          label="最后一次服务门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="lastTimeFormat"
          width="140px"
          label="最后一次服务时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="lastServer"
          label="最后一次使用服务"
        ></el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="toDetail(scope.row.id)"
              >查看会员记录</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="memberList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      pageSize: 10,
      dialogVisible: false,
      total: 100,
      currentPage: 1,
      keyWord: "",
      record: 0,
      store: "",
      dateAndTime: "",
      startDate: "",
      endDate: ""
    };
  },
  mounted() {
    this.queryList();
  },
  computed: mapGetters(["memberList", "purchaseHistory"]),
  watch: {
    dateAndTime(val) {
      this.startDate = val ? moment(val[0]).format("YYYY-MM-DD HH:mm:ss") : "";
      this.endDate = val ? moment(val[1]).format("YYYY-MM-DD HH:mm:ss") : "";
    }
  },
  methods: {
    queryList() {
      this.$store.dispatch("queryMemberList", {
        keyWord: this.keyWord,
        startDate: this.startDate,
        endDate: this.endDate,
        pageNo: this.currentPage,
        pageSize: this.pageSize
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toDetail(id) {
      this.$router.push({ name: "MemberRecord", query: { id } });
    },
    back() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style scoped lang="scss">
.record-list {
  margin: 20px auto 0;
  width: 500px;
  font-size: 14px;

  .item {
    margin-bottom: 20px;
  }
  .title {
    color: #999;
  }
  .item-header {
    padding: 12px;
    border: 1px solid #ebeef5;
  }
  .item-body {
    padding: 12px;
    border-bottom: 1px solid #ebebf5;
    border-left: 1px solid #ebebf5;
    border-right: 1px solid #ebebf5;
    .product-list {
      flex: 1;
      strong {
        color: #ff0000;
        font-weight: normal;
      }
      li {
        line-height: 28px;
      }
    }
  }
  .item-footer {
    padding: 12px;
    border-bottom: 1px solid #ebebf5;
    border-left: 1px solid #ebebf5;
    border-right: 1px solid #ebebf5;
    .total {
      color: #ff0000;
    }
  }
}
</style>
